const $ = require("jquery");

export default class Header {
    constructor() {

     }
    init() {

        let $header = $('.l-header'),
            $headerNav = $('.l-header').data("nav"),
            kvBottom;

        if($headerNav == "fix"){

            $header.addClass('is-active');

        }else{
          $(window).on('scroll', () => {
              kvBottom = $('.js-trigger').innerHeight();

              if ($(window).scrollTop() > kvBottom) {
                  $header.addClass('is-active');
              }
              else {
                  $header.removeClass('is-active');
              }
          });

          $(window).trigger('scroll');

        }

    }

}
